import { chartModule } from './chart.module';
export const ChartModule = chartModule.name;

import './ui/chart-selector/chart-selector';
import './ui/chart-settings/chart_settings_directive';
